import React, {useEffect} from 'react';
import mainImage from "../assets/main.png";
import {Box, Container, Grid, Typography} from "@mui/material";
import KakaoLoginButton from "../components/KakaoLoginButton";
import {useNavbar} from "../states/common/client";
import {DISABLED_COLOR} from "../constants/constants";
import {Link} from "react-router-dom";

const LoginPage: React.FC = () => {
    const {setNavbarBackButton, reset} = useNavbar()

    useEffect(() => {
        reset()
        setNavbarBackButton(false)
    }, []);

    return (
        <>
            <Container className={"fullscreen"}>
                <Grid direction={'column'}
                      justifyContent={'center'}
                      alignItems={'center'}
                      style={{height: '100%'}}
                      container
                >
                    <Grid item>
                        <p style={{color: "#737373", fontSize: "20px", fontWeight: 500, margin: 0}}>날짜 정하다 지치지 말고</p>
                    </Grid>
                    <Grid item>
                        <Box height={'15px'} />
                    </Grid>
                    <Grid item>
                        <p style={{color: "#38D59C", fontSize: "40px", fontWeight: 700, margin: 0}}>약속잡기</p>
                    </Grid>
                    <Grid item>
                        <Box height={'21px'} />
                    </Grid>
                    <Grid item>
                        <img src={mainImage} alt="mainImage"/>
                    </Grid>
                    <Grid item>
                        <Box height={'46px'} />
                    </Grid>
                    <Grid item>
                        <KakaoLoginButton />
                    </Grid>
                    <Grid textAlign={'center'} item>
                        <Box height={'20px'} />
                        <Typography color={DISABLED_COLOR} variant="caption" component="p">
                            첫 로그인시 계정이 자동으로 생성됩니다.
                        </Typography>
                        <Typography color={DISABLED_COLOR} variant="caption" component="p">
                            <Link to={'/policy/terms-of-service'}>이용약관</Link> 및 <Link to={'/policy/privacy'}>개인정보 처리방침</Link>에 동의하는 것으로 간주합니다.
                        </Typography>
                    </Grid>
                </Grid>
            </Container>
        </>
    );
}

export default LoginPage;